<template>
  <div class="wspo-form-control" :class="classOfType" ref="control">
    <div class="wspo-form-label" :class="{ 'wspo-red': error }">
      {{ error || label }}
    </div>
    <!-- <div class="wspo-form-output" @click="openOptions" :class="{'is-set': output}">{{ output }}</div> -->
    <input
      class="wspo-form-input"
      @click="openOptions"
      :class="{ 'is-set': output }"
      :value="output"
      readonly
    />
    <div
      class="wspo-select-chevron wspo-icon"
      :class="{ 'wspo-open': open, 'wspo-red': error }"
    ></div>
    <transition name="fade">
      <div v-show="open" style="position: relative; z-index: 2">
        <!-- <Calendar
          v-if="type === 'datepicker'"
          :open="open"
          :onSelect="handleSelect"
          :class="{ 'wspo-stick-to-right': stickToRight }"
        />
        <Nights
          v-else-if="type === 'nights'"
          :open="open"
          :onSelect="handleSelect"
          :class="{ 'wspo-stick-to-right': stickToRight }"
        />
        <Tourists
          v-else-if="type === 'tourists'"
          :open="open"
          :onSelect="handleSelect"
          :class="{ 'wspo-stick-to-right': stickToRight }"
        />-->
        <Options
          :size="size"
          :onSelect="handleSelect"
          :options="options"
          :open="open"
          :type="type"
          :selected="selected"
          :class="{ 'wspo-stick-to-right': stickToRight }"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import Options from '@/components/controls/Options.vue';
// import Calendar from '@/components/controls/Calendar.vue';
// import Nights from '@/components/controls/Nights.vue';
// import Tourists from '@/components/controls/Tourists.vue';
// import { mapState } from 'vuex';
export default {
  name: 'Select',
  props: {
    type: String,
    label: String,
    output: String,
    size: String,
    onSelect: Function,
    afterSelect: Function,
    options: Array,
    selected: [Number, String],
    error: String
  },
  components: {
    Options
    // Calendar,
    // Nights,
    // Tourists
  },
  data: function() {
    return {
      open: false,
      stickToRight: false
    };
  },
  computed: {
    classOfType() {
      return `wspo-form-control-${this.type}`;
    }
  },
  methods: {
    openOptions() {
      this.open = !this.open;
      const closeOptions = e => {
        if (this.$refs.control && this.$refs.control.contains(e.target))
          return false;

        this.open = false;
        removeEventListener('click', closeOptions);
      };
      if (this.open) {
        setTimeout(() => addEventListener('click', closeOptions), 0);
        this.checkRange();
      }
    },
    handleSelect() {
      if (this.onSelect) this.onSelect();
      if (this.afterSelect) this.afterSelect();
      this.open = false;
    },
    checkRange() {
      if (
        window.innerWidth - this.$refs.control.getBoundingClientRect().right <
        100
      )
        this.stickToRight = true;
      else this.stickToRight = false;
    }
  }
};
</script>

<style scoped>
.wspo-form-control-nights {
  flex: 2 1 100px;
}
.wspo-form-control-tourists {
  flex: 2 1 140px;
}
.wspo-select-chevron {
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 15px 12px 15px;
  cursor: pointer;
  transition: 0.3s;
  background: none;
}
.wspo-select-chevron {
  pointer-events: none;
}
.wspo-select-chevron:before {
  color: var(--color-alt);
  font-size: 18px;
  content: '\f078';
  display: block;
}
.wspo-select-chevron.wspo-open:before {
  transform: rotate(-180deg);
  transition: transform 0.3s;
}
.wspo-red,
.wspo-red:before {
  color: var(--color-second);
}
</style>
